(function($) {
  $(document).ready(function() {
    const scx_data = $("#spl_cpx_data"),
      productName = scx_data.data("title"),
      productHandle = scx_data.data("handle"),
      handleCore = productHandle.slice(0, -3),
      search_url = `https://${window.location.hostname}/search?view=json&q="${productName}"`,
      current_color = $('#curr_color').data('current-color');
    $.ajax({
      url: search_url,
      method: "GET",
      success: function(data) {
        const scxData = JSON.parse(data),
          scxResults = scxData.results;
        let $counter = 0;
//         console.log(data)
            
          $(".pr-var .var .var-val .color-selection").empty();
        $.each(scxResults, function(i, product) {
          const prodHandle = product.handle,
            prodTitle = product.title,
            prodCoreHandle = prodHandle.slice(0, -3),
            prodSwatches = product.swatch,
            prodBackupSwatches = product.swatch_backup,
            prodAvailable = product.available,
            prodColor = product.color,
            prodUrl = product.url;
          let $swatchContent = "";
          

          if (prodTitle == productName) {
            let $selected = prodTitle == productName ? "selected" : "",
              $available = prodAvailable ? "available" : "disabled",
                $link = prodAvailable ? prodUrl : 'javascript:void(0)';
            
            $swatchContent += 
                `<li class="option ${current_color === prodColor ? 'active' : '' }" data-value="${prodColor}" data-current-color="${current_color}" data-option="Color">
				  <a href='${$link}' ${$available}>
                    <div class="var-img var-value lazy-container" style="padding-bottom: 100%;">
                    <img 
						data-src="${prodSwatches}"
						class="lazyload lazy-img"
						onerror="this.onerror=null;this.src='${prodBackupSwatches}';"
						>
                    </div>
                  </a>
                </li>`
            // console.table(product)
            $counter++;
//         console.log(listContent)
          }
//           console.log($swatchContent)
          $(".pr-var .var .var-val .color-selection").append($swatchContent);
          $(".pr-var .var").removeClass('loading-color');
        });
      },
      error: function(data) {}
    });
  });
})(jQuery);
